export enum CommunicationSubscriptionGroupName {
  Marketing = 'Marketing',
  GroupUpdates = 'Group updates',
  Reminders = 'Reminders',
  Communications = 'Communications',
  GroupCommunication = 'Groups Communication',
  System = 'System',
}

export interface CommunicationSubscriptionGroup {
  id: string;
  name: CommunicationSubscriptionGroupName;
  templates: string[];
  status: 'active' | 'inactive';
}

export interface CommunicationTemplateSelector {
  func: string;
  name: string;
  params: any;
}

export enum CommunicationTemplatePlatform {
  Sms = 'sms',
  Email = 'email',
  PushNotification = 'push_notification',
  GroupChat = 'group_chat',
}

export enum CommunicationTemplateTarget {
  Accounts = 'accounts',
  Groups = 'groups',
}

export enum CommunicationTemplateStatus {
  Active = 'active',
  Inactive = 'inactive',
}

export interface CommunicationTemplateSchedule {
  active?: boolean;
  unit: 'minutes' | 'hours' | 'days';
  amount?: number;
  minute?: number;
  hour?: number;
  days?: number[];
}

export interface CommunicationTemplateMeta {
  pushData?: any;
  loginLinkConfig?: any;
  uniqueParams?: any;
}

export enum GroupChatMessageType {
  Moment = 'moment',
  Exercise = 'exercise',
}

export interface CommunicationTemplateTemplate {
  sms?: string;
  text?: string;
  templateId?: string;
  body?: string;
  title?: string;
  groupChatMessageType?: GroupChatMessageType;
  exerciseId?: string;
  message?: string;
  imageUrl?: string;
  imageHeight?: number;
  imageWidth?: number;
}

export interface CommunicationTemplate {
  id: string;
  name: string;
  target: CommunicationTemplateTarget;
  template: CommunicationTemplateTemplate;
  platform: CommunicationTemplatePlatform;
  status: CommunicationTemplateStatus;
  description: string;
  tags: string[];
  fallbackTemplate: string | null;
  selectors: CommunicationTemplateSelector[];
  meta: CommunicationTemplateMeta;
  schedule?: CommunicationTemplateSchedule;
}

export enum QuerySelectorTarget {
  Accounts = 'accounts',
  Groups = 'groups',
}

export interface QuerySelector {
  id: string;
  name: string;
  funcName: string;
  target: QuerySelectorTarget;
  standalone: boolean;
  section: string;
  selectParams: any;
  params: any;
  dateCreated: Date;
  lastUpdated: Date;
}
